import ModalDeleteFilled from '../../../../../../../../baseComponents/ModalsLayouts/ModalDeleteFilled'
import ModalSmallFilled from '../../../../../../../../baseComponents/ModalsLayouts/ModalSmallFilled'
import { ModalEditComponentProps } from '../../../../../../../../baseComponents/ModalsLayouts/types'
import { useFetchText } from '../../../../../../../../utils/hooks/useFetchText'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'

interface ModalChangeActiveWorkSheetGroupStatusProps extends ModalEditComponentProps { }

const ModalChangeActiveWorkSheetGroupStatus: React.FC<ModalChangeActiveWorkSheetGroupStatusProps> = ({ setOpened, onSubmit, allRowData }) => {
    if (allRowData?.active === false) {
        return <ModalReactivateWorkSheetGroupStatus {...{ setOpened, onSubmit, allRowData }} />
    } else {
        return <ModalDeleteWorkSheetGroupStatus {...{ setOpened, onSubmit, allRowData }} />
    }
}


interface ModalReactivateWorkSheetGroupStatusProps extends ModalEditComponentProps { }

const ModalReactivateWorkSheetGroupStatus: React.FC<ModalReactivateWorkSheetGroupStatusProps> = ({ setOpened, onSubmit, allRowData }) => {
    const { t } = useTwinTranslation()
    const { handleFetchText } = useFetchText({
        onSubmit,
        url: '/api/app/order/sell/workSheet/workSheetGroupStatus/reactiveWorkSheetGroupStatus',
        data: {
            id: allRowData?.id,
            active: true
        }
    })
    return (
        <ModalSmallFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleFetchText} translations={{
            title: t('sureReactiveThisWorkSheetGroupStatus', '¿Seguro que quieres reactivar este grupo de estado?'),
            subtitle: t('onceReactivatedAbleInWorkSheetGroupStatusList', 'Una vez reactivado volverá a aparecer en el listado de grupos de estado'),
            buttonAccept: t('reactivate', 'Reactivar')
        }} />
    )
}


interface ModalDeleteWorkSheetGroupStatusProps extends ModalEditComponentProps { }

const ModalDeleteWorkSheetGroupStatus: React.FC<ModalDeleteWorkSheetGroupStatusProps> = ({ setOpened, onSubmit, allRowData }) => {
    const { t } = useTwinTranslation()
    const { handleFetchText } = useFetchText({
        onSubmit,
        url: '/api/app/order/sell/workSheet/workSheetGroupStatus/deleteWorkSheetGroupStatus',
        data: {
            id: allRowData?.id,
            active: false
        }
    })
    return (
        <ModalDeleteFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleFetchText} translations={{
            title: t('sureDeleteWorkSheetGroupStatus', '¿Seguro que quieres eliminar este grupo de estado?'),
            subtitle: t('onceDeletedCanRecover', 'Una vez eliminado podrás reactivarlo')
        }} />
    )
}

export default ModalChangeActiveWorkSheetGroupStatus